import {barrel as barrelConfig} from 'cfg/slot-config';
import {Barrel} from 'barrel';

import MainScene from './mainscene';

import {doublegame as doubleGameConfig} from 'cfg/doublegame-config';
import FiveCardRisk from './doublegamescene';

import BonusGameScene from './bonusgame_scene';
import SuperBonusGameScene from './superbonusgame_scene';

import helpConfig from 'cfg/help-config';
import {HelpScene} from 'helpscene';

import SlotMath from './japan_math';

import { TYPE} from "network/network_api";

export default function construct(spec, space ) {
    
    const mathSpec = {
        lines: spec.specification.linesCountMax,
        symbols: spec.specification.symbolsCount,
        wild: spec.specification.symbolWild,
        scatter: spec.specification.symbolScatter,
        bonus: spec.specification.symbolBonus,
        trajectories: spec.specification.linesPaths,
        price: spec.specification.priceList,
        scatterPrice: spec.specification.scatterWinCoeffs,
        substitutableElements: spec.specification.substitutableElements,
        wildLineWinMultiplier: spec.specification.wildLineWinMultiplier,
        freegamesMultiplier: spec.specification.freeSpinWinMultiplier,
        winShapes: spec.specification.winShapes,
        reels: 5,
        rows: 3,
        bonusWinCondition: 3
    };

    const secondChanceTreshold =  spec.specification.secondChanceTreshold;

    const math = new SlotMath(mathSpec);
    
    const barrel = new Barrel(barrelConfig, barrelConfig.symbolsCount);
    
    const slotScene = new MainScene(spec, math, secondChanceTreshold);
    slotScene.setBarrel(barrel);
    
    // в спеке может бюыть несколько спецификаций рисков
    for (let i = 0; i < spec.risks.length; i++) {
        // предположим что это нужная нам спецификация
        if (spec.risks[i].specification.riskId === 1) {
            doubleGameConfig.suits = spec.risks[i].specification.suitNames;
        }
    }
    
    const doubleGameScene = new FiveCardRisk(doubleGameConfig);
    doubleGameScene.visible = false;
    
    const bonusGameScene = new BonusGameScene(space, secondChanceTreshold);
    bonusGameScene.visible = false;

    const superBonusGameScene = new SuperBonusGameScene(space);
    superBonusGameScene.visible = false;
    
    const helpScene = new HelpScene(null/*controller*/, null/*model*/, math, helpConfig.help);
    helpScene.visible = false;
    
    return {
        barrel,
        slotScene: {
            view:slotScene,
            z:0
        },
        doubleGameScene: {
            view:doubleGameScene,
            z:1
        },
        helpScene: {
            view:helpScene,
            z:2
        },
        bonusScene: {
            view: bonusGameScene,
            z:3
        },
        superBonusScene: {
            view: superBonusGameScene,
            z:4
        },
        reactive
    };
}

function reactive(space, construct) {

    const slot = construct.slotScene.view;
    const bonus = construct.bonusScene.view;
    const superBonus = construct.superBonusScene.view;
    const risk = construct.doubleGameScene.view;

    space.s('ui:price').on(bet => {
        slot.extraLife.visible = (bet > bonus.secondChance);
    });

    space.s('risk:enter').on(() => {risk.animateBack.startAnimate()});
    space.s('risk:leave').on(() => {risk.animateBack.stopAnimate()});

    const sndEnterHelp = sounds.get("res/sounds/help/help_enter");
    const sndExitHelp = sounds.get("res/sounds/help/help_exit");

    space.s('ui:info').on(() => {
        sndEnterHelp.play()
    });
    space.s('ui:helpExit').on(() => {
        sndEnterHelp.stop();
        sndExitHelp.play();
    });

    const $toState = space.s("game_state", {});
    space.s("state").to($toState);
    const $statesPair = $toState.pairwise();

    const $showBonusResult = space.s("bonus:showResult").alter();
    space.s("bonus:showResult")
        .withLatestFrom($statesPair, (result, [prev, state]) => ({result, prev, state}))
        .on(
            ({result, prev, state}) => {
                //console.log("RESULT ", result);

                const previousState = prev;

                if (previousState.type === undefined || (previousState.type != TYPE.BONUS_1 && state.type != TYPE.BONUS_1)){
                    bonus.restoreBonus(result);
                }

                $showBonusResult.next(result);
                bonus.visible = true;
                space.s("ui:isBonus").next(true);

            }
        );

    space.s( "bonus:end" ).on(() => {
        bonus.pause();
    });

    const $showSuperBonusResult = space.s("superbonus:showResult").alter();
    space.s("superbonus:showResult")
        .withLatestFrom($statesPair, (result, [prev, state]) => ({result, prev, state}))
        .on(
            ({result, prev, state}) => {

                const previousState = prev;

                const scenarioData = result.server.scenarioData || [];
                if (previousState.type === undefined || (previousState.type != TYPE.BONUS_2 && scenarioData.length === 0)){
                    superBonus.restoreBonus(result);
                }
                $showSuperBonusResult.next(result);
            }
        );

    space.s( "superbonus:end" ).on(() => {
        superBonus.pause();
    });

    const ENTER = 13;
    const SPACE = 32;
    const F8    = 119;
    space.s( "keyboard" )
        .map( k => ({ k }) )
        .to( space.s( "bonus:tryChoice_1" ) );

    space.s( "bonus:choice_1" )
        .filter( ({ can }) => can )
        .on( ({ k }) => {
            switch ( k )
            {
                case SPACE:
                case ENTER:
                case F8:
                    bonus.selectCell();
                    break;
                default:
                    break;
            }
        } );

    space.s( "keyboard" )
        .map( k => ({ k }) )
        .to( space.s( "bonus:tryChoice_2" ) );

    space.s( "bonus:choice_2" )
        .filter( ({ can }) => can )
        .on( ({ k }) => {
            switch ( k )
            {
                case SPACE:
                case ENTER:
                case F8:
                    superBonus.selectPrize();
                    break;
                default:
                    break;
            }
        } );

    $statesPair.filter (([prev, state]) => (prev.type == undefined && state.type == TYPE.FINISH))
        .map(() => {})
        .to(space.s('ui:finish'));

    $statesPair.filter (([prev, state]) => (prev.type != undefined && state.type == TYPE.FINISH))
        .map(() => true)
        .to(space.s('ui:isBonus'));

    space.s('ui:finish').on(() => {
        space.s('ui:isBonus').next(false);
    });


}






// WEBPACK FOOTER //
// ./src/construct.es6